/**
 * MCH Theme Enhancements JS
 * Newsletter popup, FAQ accordion, wishlist, back-to-top, size guide
 *
 * Loaded on idle (from theme.liquid) to keep ~28 KB off the critical parse
 * path. The guard below handles the case where DOMContentLoaded already
 * fired by the time this script is appended to the DOM.
 */

// Shared body overflow lock — prevents scroll conflicts between drawers/modals
window.mchOverflowLocks = window.mchOverflowLocks || new Set();
window.mchLockScroll = function(id) { window.mchOverflowLocks.add(id); document.body.style.overflow = 'hidden'; };
window.mchUnlockScroll = function(id) { window.mchOverflowLocks.delete(id); if (window.mchOverflowLocks.size === 0) document.body.style.overflow = ''; };

function mchEnhancementsInit() {

  /* ===== NEWSLETTER POPUP — configurable via theme editor ===== */
  (function() {
    var overlay = document.querySelector('.newsletter-overlay');
    if (!overlay) return;

    var config = {};
    try { config = JSON.parse(overlay.dataset.config || '{}'); } catch(e) { return; }
    if (!config.enabled) return;

    // Page targeting (template name rendered by Liquid on data-template)
    var template = overlay.dataset.template || '';
    var pageKind = 'pages';
    if (template === 'index') pageKind = 'home';
    else if (template.indexOf('product') === 0) pageKind = 'pdp';
    else if (template.indexOf('collection') === 0 || template === 'list-collections') pageKind = 'collection';
    else if (template === 'cart') pageKind = 'cart';
    var pageAllowed = (
      (pageKind === 'home'       && config.show_home)       ||
      (pageKind === 'pdp'        && config.show_pdp)        ||
      (pageKind === 'collection' && config.show_collection) ||
      (pageKind === 'cart'       && config.show_cart)       ||
      (pageKind === 'pages'      && config.show_pages)
    );
    if (!pageAllowed) return;

    // Device targeting
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (config.device === 'desktop' && isMobile) return;
    if (config.device === 'mobile' && !isMobile) return;

    // Frequency / conversion caps
    var subscribed = false;
    try { subscribed = !!localStorage.getItem('mch_newsletter_subscribed'); } catch(e) {}
    if (config.hide_after_conversion && subscribed) return;

    if (config.frequency === 'once_per_session') {
      try { if (sessionStorage.getItem('mch_popup_shown')) return; } catch(e) {}
    } else if (config.frequency === 'once_per_days') {
      try {
        var last = parseInt(localStorage.getItem('mch_popup_last_shown') || '0', 10);
        if (last > 0) {
          var daysElapsed = (Date.now() - last) / (1000 * 60 * 60 * 24);
          if (daysElapsed < (config.frequency_days || 14)) return;
        }
      } catch(e) {}
    }

    // A/B variant selection
    var variants = Array.prototype.slice.call(overlay.querySelectorAll('.newsletter-popup__variant'));
    if (variants.length === 0) return;
    var chosen;
    if (!config.ab_testing || variants.length === 1) {
      chosen = variants[0];
    } else {
      var stickyIdx = -1;
      try {
        var raw = localStorage.getItem('mch_popup_variant');
        var parsed = raw === null ? -1 : parseInt(raw, 10);
        if (parsed >= 0 && parsed < variants.length) stickyIdx = parsed;
      } catch(e) {}
      if (stickyIdx < 0) {
        stickyIdx = Math.floor(Math.random() * variants.length);
        try { localStorage.setItem('mch_popup_variant', String(stickyIdx)); } catch(e) {}
      }
      chosen = variants[stickyIdx];
    }
    variants.forEach(function(v) { if (v !== chosen) v.remove(); });

    // Defer background image until the popup is actually about to show —
    // most visitors never see the popup, no reason to fetch its hero image.
    var bgHost = chosen.querySelector('[data-bg-image]');
    var bgUrl = bgHost ? bgHost.dataset.bgImage : null;
    var bgPreloaded = false;
    function ensureBgLoaded() {
      if (bgPreloaded || !bgHost || !bgUrl) return;
      bgPreloaded = true;
      bgHost.style.backgroundImage = 'linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),url(' + bgUrl + ')';
    }

    // Triggers
    var fired = false;
    var timer = null;
    var _popupPrevFocus = null;
    function show() {
      if (fired) return;
      fired = true;
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExitIntent);
      try { sessionStorage.setItem('mch_popup_shown', '1'); } catch(e) {}
      try { localStorage.setItem('mch_popup_last_shown', String(Date.now())); } catch(e) {}
      ensureBgLoaded();
      _popupPrevFocus = document.activeElement;
      overlay.classList.add('active');
      if (window.mchLockScroll) window.mchLockScroll('popup');
      // Notify any listeners (scratch card init etc.) that the popup is now visible
      // and laid out — they need real bounding-box sizes for canvas init.
      try { chosen.dispatchEvent(new CustomEvent('mch-popup-shown', { bubbles: false })); } catch(_e) {}
      // Give screen readers + keyboard users an anchor inside the dialog.
      var initialFocus = chosen.querySelector('.newsletter-popup__close') || chosen.querySelector('input,button');
      if (initialFocus) setTimeout(function(){ initialFocus.focus(); }, 50);
    }
    function close() {
      overlay.classList.remove('active');
      if (window.mchUnlockScroll) window.mchUnlockScroll('popup');
      if (_popupPrevFocus && typeof _popupPrevFocus.focus === 'function') {
        _popupPrevFocus.focus();
        _popupPrevFocus = null;
      }
    }
    function onScroll() {
      if (fired) return;
      var denom = document.body.scrollHeight - window.innerHeight;
      if (denom <= 0) return;
      var pct = (window.scrollY / denom) * 100;
      if (pct >= (config.scroll_percent || 40)) show();
    }
    function onExitIntent(e) {
      if (fired) return;
      if (!e.relatedTarget && e.clientY <= 2) show();
    }

    var useTime = config.trigger === 'time' || config.trigger === 'combined';
    var useScroll = config.trigger === 'scroll' || config.trigger === 'combined';
    var useExit = config.trigger === 'exit_intent' && !isMobile;
    // On mobile, exit_intent falls back to time.
    if (config.trigger === 'exit_intent' && isMobile) useTime = true;

    if (useTime) timer = setTimeout(show, (config.delay_seconds || 0) * 1000);
    if (useScroll) window.addEventListener('scroll', onScroll, { passive: true });
    if (useExit) document.addEventListener('mouseout', onExitIntent);

    // Close handlers
    var closeBtn = chosen.querySelector('.newsletter-popup__close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    var noThanks = chosen.querySelector('.newsletter-popup__no-thanks');
    if (noThanks) noThanks.addEventListener('click', close);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function(e) {
      if (!overlay.classList.contains('active')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var focusable = chosen.querySelectorAll('button, a[href], input:not([type="hidden"]):not([tabindex="-1"]), textarea, [tabindex]:not([tabindex="-1"])');
        if (focusable.length === 0) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Success-state swap — listens for the shared lead form handler's custom event.
    // If response carried a discount_code, render Stage 3 (code chip + copy).
    // Otherwise fall back to the legacy heading/text replace inside data-popup-body.
    chosen.addEventListener('mch-lead-success', function(e) {
      var detail = (e && e.detail) || {};
      var discountCode = detail.discountCode || '';
      var discountExpiresAt = detail.discountExpiresAt || '';
      var autoClose = parseInt(chosen.dataset.successAutoClose || '0', 10);

      var claim = chosen.querySelector('[data-scratch-claim]');
      var codeBox = chosen.querySelector('[data-scratch-code]');

      if (discountCode && codeBox) {
        // Stage 3: code reveal
        var valueEl = codeBox.querySelector('[data-scratch-code-value]');
        var expiryEl = codeBox.querySelector('[data-scratch-code-expiry]');
        var copyBtn = codeBox.querySelector('[data-scratch-code-copy]');
        if (valueEl) valueEl.textContent = discountCode;
        if (expiryEl && discountExpiresAt) {
          var d = new Date(discountExpiresAt);
          if (!isNaN(d.getTime())) {
            // Serbian locale: "do 5. juna 2026."
            var fmt;
            try { fmt = d.toLocaleDateString('sr-RS', { day: 'numeric', month: 'long', year: 'numeric' }); }
            catch (err) { fmt = d.toISOString().slice(0, 10); }
            expiryEl.textContent = 'Važi do ' + fmt;
          }
        }
        if (copyBtn && !copyBtn.dataset.bound) {
          copyBtn.dataset.bound = '1';
          copyBtn.addEventListener('click', function() {
            var t = (valueEl && valueEl.textContent) || '';
            if (!t) return;
            var done = function() { copyBtn.classList.add('is-copied'); setTimeout(function(){ copyBtn.classList.remove('is-copied'); }, 1800); };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(t).then(done, done);
            } else {
              // Legacy fallback
              var ta = document.createElement('textarea'); ta.value = t; document.body.appendChild(ta);
              ta.select(); try { document.execCommand('copy'); } catch(_e) {}
              document.body.removeChild(ta); done();
            }
          });
        }
        if (claim) claim.hidden = true;
        codeBox.hidden = false;

        // Auto-apply the discount in the customer's cart session in the
        // background AND route the CTA through the discount link so clicking
        // "Nastavi kupovinu" both applies the code and navigates. The copy
        // button stays for users who prefer manual entry. Three paths to a
        // working code; failure of one doesn't block the others.
        var encodedCode = encodeURIComponent(discountCode);
        try {
          fetch('/discount/' + encodedCode, { credentials: 'same-origin' }).catch(function(){});
        } catch (_e) {}
        var cta = codeBox.querySelector('.scratch-code__cta');
        if (cta) {
          var origHref = cta.getAttribute('href') || '/collections/all';
          cta.setAttribute('href', '/discount/' + encodedCode + '?redirect=' + encodeURIComponent(origHref));
        }

        // Don't auto-close when showing a code — user needs time to copy it.
        return;
      }

      // Fallback: no code in response (mint failed or non-popup source). Use legacy
      // success-text rendering inside the popup body.
      var body = chosen.querySelector('[data-popup-body]');
      if (!body) return;
      var head = chosen.dataset.successHeading || 'Hvala!';
      var text = chosen.dataset.successText || (detail.message || '');
      body.innerHTML =
        '<div class="newsletter-popup__title newsletter-popup__title--success">' + escapeText(head) + '</div>' +
        '<div class="newsletter-popup__text newsletter-popup__text--success">' + escapeText(text) + '</div>';
      if (autoClose > 0) setTimeout(close, autoClose * 1000);
    });

    function escapeText(s) {
      var d = document.createElement('div'); d.textContent = String(s); return d.innerHTML;
    }
  })();

  /* ===== MCH LEAD FORMS — single handler for popup / footer / restock ===== */
  (function() {
    var LEAD_API = (window.MCH_LEAD_API) || 'https://mch-reviews-backend.vercel.app/api/lead';

    document.addEventListener('submit', function(e) {
      var form = e.target.closest('.mch-lead-form');
      if (!form) return;
      e.preventDefault();

      var statusEl = form.querySelector('[data-lead-status]');
      var btn = form.querySelector('button[type="submit"]');
      var origBtnText = btn ? btn.textContent : '';
      var source = form.dataset.leadSource || '';

      if (statusEl) { statusEl.textContent = ''; statusEl.className = statusEl.className.replace(/\s*mch-lead-status--\w+/g, ''); }
      if (!form.reportValidity()) return;
      if (btn) { btn.disabled = true; btn.textContent = '…'; }

      var fd = new FormData(form);
      fd.set('source', source);
      // Cloudflare Turnstile — include token if widget is present
      var tsToken = form.querySelector('[name="cf-turnstile-response"]');
      if (tsToken && tsToken.value) fd.set('turnstile_token', tsToken.value);
      var body = new URLSearchParams();
      fd.forEach(function(v, k) { body.append(k, typeof v === 'string' ? v : ''); });

      fetch(LEAD_API, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      })
        .then(function(r) { return r.json().then(function(j) { return { ok: r.ok, data: j }; }); })
        .then(function(res) {
          if (res.ok && res.data.ok) {
            if (source === 'newsletter_popup' || source === 'newsletter_footer') {
              try { localStorage.setItem('mch_newsletter_subscribed', '1'); } catch(e) {}
            }
            var msg = res.data.message || 'Hvala.';
            if (source === 'newsletter_popup') {
              // Fire event up to the popup section; section's own handler swaps
              // in the per-variant success heading/text and handles auto-close.
              // For the scratch flow, the response also carries a unique
              // discount_code (single-use 10% off, 30-day expiry) which the
              // popup handler renders into the Stage 3 code chip.
              var variantEl = form.closest('.newsletter-popup__variant');
              if (variantEl) {
                variantEl.dispatchEvent(new CustomEvent('mch-lead-success', {
                  detail: {
                    message: msg,
                    discountCode: (res.data && res.data.discount_code) || '',
                    discountExpiresAt: (res.data && res.data.discount_expires_at) || ''
                  },
                  bubbles: false
                }));
              } else {
                // Fallback if structure changed
                form.innerHTML = '<p class="mch-lead-success">' + escapeText(msg) + '</p>';
              }
            } else {
              // Footer / restock: swap form with inline success
              form.innerHTML = '<p class="mch-lead-success">' + escapeText(msg) + '</p>';
            }
          } else {
            if (statusEl) { statusEl.textContent = (res.data && res.data.error) || 'Greška. Pokušaj ponovo.'; statusEl.className += ' mch-lead-status--error'; }
            if (btn) { btn.disabled = false; btn.textContent = origBtnText; }
            resetTurnstile(form);
          }
        })
        .catch(function() {
          if (statusEl) { statusEl.textContent = 'Nema veze sa serverom. Pokušaj ponovo.'; statusEl.className += ' mch-lead-status--error'; }
          if (btn) { btn.disabled = false; btn.textContent = origBtnText; }
          resetTurnstile(form);
        });
    });

    function resetTurnstile(form) {
      if (!window.turnstile) return;
      var widget = form.querySelector('.cf-turnstile');
      if (widget) { try { window.turnstile.reset(widget); } catch (e) {} }
    }

    function escapeText(s) {
      var d = document.createElement('div'); d.textContent = String(s); return d.innerHTML;
    }
  })();

  /* ===== SCRATCH CARD — canvas-based "scratch to reveal" for popup ===== */
  // Initializes canvases on DOMContentLoaded for any visible card, and
  // re-initializes when the newsletter popup dispatches `mch-popup-shown`
  // (canvas needs real bounding-box sizes, which it doesn't have while the
  // popup is display:none).
  (function() {
    var BRUSH_RADIUS = 40;
    var SAMPLE_INTERVAL_MS = 80;

    function initCard(card) {
      if (!card || card.dataset.scratchReady === '1') return;
      var canvas = card.querySelector('[data-scratch-surface]');
      var hint = card.querySelector('[data-scratch-hint]');
      if (!canvas) return;
      var rect = card.getBoundingClientRect();
      // Card not laid out yet (e.g. inside a display:none popup) — defer.
      if (rect.width < 8 || rect.height < 8) return;

      card.dataset.scratchReady = '1';
      var threshold = parseFloat(card.dataset.revealThreshold || '0.30');
      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;

      function paintSurface() {
        var r = card.getBoundingClientRect();
        canvas.width = Math.max(1, Math.floor(r.width * dpr));
        canvas.height = Math.max(1, Math.floor(r.height * dpr));
        canvas.style.width = r.width + 'px';
        canvas.style.height = r.height + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        // Solid gold gradient surface — no stipple, cleaner uniform look.
        var grad = ctx.createLinearGradient(0, 0, r.width, r.height);
        grad.addColorStop(0, '#E8A52C');
        grad.addColorStop(1, '#F2C268');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, r.width, r.height);
      }
      paintSurface();

      var resizeRaf = 0;
      function onResize() {
        if (card.classList.contains('is-revealed')) return;
        cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(paintSurface);
      }
      window.addEventListener('resize', onResize);

      var scratching = false;
      var lastPercent = 0;
      var lastSampleAt = 0;
      var lastX = null;
      var lastY = null;

      function getPos(e) {
        var r = canvas.getBoundingClientRect();
        var cx = (typeof e.clientX === 'number' ? e.clientX : (e.touches && e.touches[0] ? e.touches[0].clientX : 0));
        var cy = (typeof e.clientY === 'number' ? e.clientY : (e.touches && e.touches[0] ? e.touches[0].clientY : 0));
        return { x: cx - r.left, y: cy - r.top };
      }

      // Erase by drawing a thick rounded line from the last point to the current
      // point. Connected lines (instead of isolated arcs) eliminate gaps between
      // fast pointermove events, so the scratch trail looks crisp and continuous
      // rather than patchy/faded.
      function carve(p) {
        ctx.globalCompositeOperation = 'destination-out';
        if (lastX !== null && lastY !== null) {
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';
          ctx.lineWidth = BRUSH_RADIUS * 2;
          ctx.beginPath();
          ctx.moveTo(lastX, lastY);
          ctx.lineTo(p.x, p.y);
          ctx.stroke();
        } else {
          ctx.beginPath();
          ctx.arc(p.x, p.y, BRUSH_RADIUS, 0, Math.PI * 2);
          ctx.fill();
        }
        lastX = p.x;
        lastY = p.y;
      }

      function checkProgress() {
        var now = Date.now();
        if (now - lastSampleAt < SAMPLE_INTERVAL_MS) return;
        lastSampleAt = now;
        var w = canvas.width, h = canvas.height;
        if (w < 4 || h < 4) return;
        var data;
        try { data = ctx.getImageData(0, 0, w, h).data; } catch (_e) { return; }
        // Sample alpha every 16th pixel for a cheap clear-percentage estimate.
        var clear = 0, total = 0;
        for (var i = 3; i < data.length; i += 64) {
          total++;
          if (data[i] === 0) clear++;
        }
        if (total === 0) return;
        var pct = clear / total;
        if (pct > lastPercent) lastPercent = pct;
        if (lastPercent >= threshold) reveal();
      }

      function reveal() {
        if (card.classList.contains('is-revealed')) return;
        card.classList.add('is-revealed');
        // After fade transition, show the claim form. Don't remove the canvas
        // listener immediately — pointercancel may still fire.
        setTimeout(function() {
          var variant = card.closest('.newsletter-popup__variant');
          var claim = variant && variant.querySelector('[data-scratch-claim]');
          if (claim) claim.hidden = false;
          // Move focus into the email input for keyboard users.
          var firstInput = claim && claim.querySelector('input[type="email"]');
          if (firstInput) try { firstInput.focus(); } catch(_e) {}
        }, 550);
      }

      function onDown(e) {
        scratching = true;
        // Reset lastX/lastY so the first carve in this stroke draws an arc
        // (no line back to a previous-stroke endpoint elsewhere on the card).
        lastX = lastY = null;
        if (hint && !hint.classList.contains('is-faded')) hint.classList.add('is-faded');
        try { canvas.setPointerCapture(e.pointerId); } catch(_e) {}
        carve(getPos(e));
      }
      function onMove(e) {
        if (!scratching) return;
        e.preventDefault();
        carve(getPos(e));
        checkProgress();
      }
      function onUp() { scratching = false; lastX = lastY = null; checkProgress(); }

      canvas.addEventListener('pointerdown', onDown);
      canvas.addEventListener('pointermove', onMove);
      canvas.addEventListener('pointerup', onUp);
      canvas.addEventListener('pointercancel', onUp);
      canvas.addEventListener('pointerleave', onUp);
    }

    function initAllIn(root) {
      (root || document).querySelectorAll('[data-scratch-card]').forEach(initCard);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initAllIn(); });
    } else {
      initAllIn();
    }

    // The popup is display:none until trigger fires; canvas needs real layout
    // dimensions, so initialize lazily on the popup-shown event.
    document.addEventListener('mch-popup-shown', function(e) {
      // Slight delay: let the open animation lay out the popup before sizing.
      setTimeout(function() { initAllIn(e.target); }, 60);
    }, true);
  })();

  /* ===== LOOKBOOK BAND — image rotator with 5 transition types ===== */
  (function() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.lookbook-band__slides').forEach(function(stage) {
      var slides = stage.querySelectorAll('.lookbook-band__slide');
      if (slides.length < 2) return;

      var band = stage.closest('.lookbook-band');
      var transition = (band && band.dataset.transition) || 'fade';
      var intervalSec = parseFloat(stage.dataset.interval || '1');
      if (!(intervalSec > 0)) intervalSec = 1;
      var intervalMs = Math.max(400, intervalSec * 1000);
      if (prefersReducedMotion) intervalMs = Math.max(intervalMs, 4000);

      var current = 0;
      var timer = null;
      var leavingTimer = null;

      function tick() {
        if (document.hidden) return;
        var prev = current;
        current = (current + 1) % slides.length;
        // For slide transitions, the previous slide needs an `is-leaving` class
        // so CSS can animate it out while the new one enters.
        slides[prev].classList.remove('is-active');
        slides[prev].classList.add('is-leaving');
        slides[current].classList.add('is-active');
        clearTimeout(leavingTimer);
        leavingTimer = setTimeout(function() {
          slides[prev].classList.remove('is-leaving');
        }, Math.max(800, intervalMs));
      }
      function start() {
        stop();
        timer = setInterval(tick, intervalMs);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      document.addEventListener('visibilitychange', function() {
        if (document.hidden) stop(); else start();
      });

      var pauseOnHover = (stage.dataset.pauseOnHover === 'true');
      if (pauseOnHover && !window.matchMedia('(hover: none)').matches && band) {
        band.addEventListener('mouseenter', stop);
        band.addEventListener('mouseleave', start);
      }

      start();
    });
  })();

  /* ===== FAQ ACCORDION ===== */
  document.querySelectorAll('.faq-item__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.faq-item');
      var wasActive = item.classList.contains('active');
      // Close all siblings — scoped to this FAQ list, not document-wide
      var list = btn.closest('.faq-list') || document;
      list.querySelectorAll('.faq-item.active').forEach(function(el) {
        el.classList.remove('active');
        var sibBtn = el.querySelector('.faq-item__question');
        if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
      });
      if (wasActive) {
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ===== BACK TO TOP ===== */
  (function() {
    var btn = document.querySelector('.back-to-top');
    if (!btn) return;
    var ticking = false;
    var lastVisible = false;
    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        var shouldBe = window.scrollY > 500;
        if (shouldBe !== lastVisible) {
          lastVisible = shouldBe;
          btn.classList.toggle('visible', shouldBe);
        }
        ticking = false;
      });
    }, {passive: true});
    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  /* ===== WISHLIST ===== */
  (function() {
    var wishlist = [];
    try { wishlist = JSON.parse(localStorage.getItem('mch_wishlist') || '[]'); } catch(e) { wishlist = []; }
    var toast = document.querySelector('.wishlist-toast');
    var drawerEl = document.querySelector('.wishlist-drawer');
    var overlayEl = document.querySelector('.wishlist-drawer-overlay');
    var bodyEl = document.getElementById('wishlistDrawerBody');
    var itemsEl = document.getElementById('wishlistItems');
    var emptyEl = document.getElementById('wishlistEmpty');

    function isInWishlist(id) { return wishlist.indexOf(id) > -1; }
    function saveWishlist() { try { localStorage.setItem('mch_wishlist', JSON.stringify(wishlist)); } catch(e) {} }

    // Cache: id → array of button elements. Built once; avoids re-querying the DOM
    // on every wishlist toggle or cross-tab sync.
    var wishlistBtnsById = new Map();
    var wishlistCountEls = document.querySelectorAll('.wishlist-count');
    function cacheWishlistButtons() {
      wishlistBtnsById.clear();
      document.querySelectorAll('[data-wishlist-id]').forEach(function(b) {
        var id = b.dataset.wishlistId;
        if (!id) return;
        var list = wishlistBtnsById.get(id);
        if (!list) { list = []; wishlistBtnsById.set(id, list); }
        list.push(b);
      });
    }

    // Cross-tab sync
    window.addEventListener('storage', function(e) {
      if (e.key === 'mch_wishlist') {
        try { wishlist = JSON.parse(e.newValue || '[]'); } catch(err) { wishlist = []; }
        updateCount();
        wishlistBtnsById.forEach(function(buttons, id) {
          var inList = isInWishlist(id);
          buttons.forEach(function(b) { b.classList.toggle('active', inList); });
        });
      }
    });

    function updateCount() {
      wishlistCountEls.forEach(function(el) {
        el.textContent = wishlist.length;
        el.style.display = wishlist.length > 0 ? 'flex' : 'none';
      });
    }

    function updateAllButtons(id) {
      var inList = isInWishlist(id);
      var buttons = wishlistBtnsById.get(id) || [];
      buttons.forEach(function(b) {
        b.classList.toggle('active', inList);
        if (b.classList.contains('product-info__wishlist-btn')) {
          var svg = b.querySelector('svg');
          if (svg) {
            b.textContent = '';
            b.appendChild(svg);
            b.appendChild(document.createTextNode(inList ? ' Na listi želja ❤️' : ' Dodaj na listu želja'));
          }
        }
      });
      updateCount();
    }

    // Mark existing wishlist items on page load
    cacheWishlistButtons();
    wishlistBtnsById.forEach(function(buttons, id) {
      if (!isInWishlist(id)) return;
      buttons.forEach(function(btn) {
        btn.classList.add('active');
        if (btn.classList.contains('product-info__wishlist-btn')) {
          var svg = btn.querySelector('svg');
          if (svg) {
            btn.textContent = '';
            btn.appendChild(svg);
            btn.appendChild(document.createTextNode(' Na listi želja ❤️'));
          }
        }
      });
    });
    updateCount();

    // Toggle wishlist on product cards and product page buttons
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__wishlist, .product-info__wishlist-btn');
      if (!btn || !btn.dataset.wishlistId) return;
      e.preventDefault();
      e.stopPropagation();

      var id = btn.dataset.wishlistId;
      var idx = wishlist.indexOf(id);
      if (idx > -1) {
        wishlist.splice(idx, 1);
        showToast('Uklonjeno sa liste želja');
      } else {
        wishlist.push(id);
        showToast('Dodato na listu želja ❤️');
      }
      saveWishlist();
      updateAllButtons(id);
    }, true);

    // ===== DRAWER OPEN/CLOSE =====
    var _wishlistTriggerEl = null;
    function openDrawer() {
      if (!drawerEl || !overlayEl) return;
      _wishlistTriggerEl = document.activeElement;
      drawerEl.classList.add('active');
      overlayEl.classList.add('active');
      window.mchLockScroll('wishlist');
      loadDrawerItems();
      var closeFocus = drawerEl.querySelector('.wishlist-drawer__close');
      if (closeFocus) setTimeout(function(){ closeFocus.focus(); }, 100);
    }
    function closeDrawer() {
      if (!drawerEl || !overlayEl) return;
      drawerEl.classList.remove('active');
      overlayEl.classList.remove('active');
      window.mchUnlockScroll('wishlist');
      if (_wishlistTriggerEl && typeof _wishlistTriggerEl.focus === 'function') {
        _wishlistTriggerEl.focus();
        _wishlistTriggerEl = null;
      }
    }

    // Trigger: header heart icon
    document.querySelectorAll('.wishlist-drawer-trigger').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });
    if (overlayEl) overlayEl.addEventListener('click', closeDrawer);
    var closeBtn = drawerEl ? drawerEl.querySelector('.wishlist-drawer__close') : null;
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawerEl && drawerEl.classList.contains('active')) closeDrawer();
      // FIX: CART-NO-FOCUS-TRAP — trap Tab inside wishlist drawer
      if (e.key === 'Tab' && drawerEl && drawerEl.classList.contains('active')) {
        var focusable = drawerEl.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
        if (focusable.length === 0) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
    });

    // ===== LOAD PRODUCTS INTO DRAWER =====
    function loadDrawerItems() {
      if (!itemsEl || !emptyEl) return;
      if (wishlist.length === 0) {
        emptyEl.style.display = 'block';
        itemsEl.innerHTML = '';
        return;
      }
      emptyEl.style.display = 'none';
      itemsEl.innerHTML = '<div class="wishlist-drawer__loading">Učitavam…</div>';

      // Fetch product data in batches of 5 with caching
      var productCache = window._mchProductCache || {};
      window._mchProductCache = productCache;

      function fetchBatch(handles) {
        var results = [];
        var toFetch = [];
        handles.forEach(function(h) {
          if (productCache[h]) results.push({ handle: h, data: productCache[h] });
          else toFetch.push(h);
        });
        if (toFetch.length === 0) {
          return Promise.resolve(handles.map(function(h) { return productCache[h] || null; }));
        }
        // Fetch in chunks of 5 to avoid network congestion
        var chunks = [];
        for (var i = 0; i < toFetch.length; i += 5) {
          chunks.push(toFetch.slice(i, i + 5));
        }
        return chunks.reduce(function(chain, chunk) {
          return chain.then(function() {
            return Promise.all(chunk.map(function(handle) {
              return fetch('/products/' + handle + '.js')
                .then(function(r) { return r.ok ? r.json() : null; })
                .then(function(data) { if (data) productCache[handle] = data; return data; })
                .catch(function() { return null; });
            }));
          });
        }, Promise.resolve()).then(function() {
          return handles.map(function(h) { return productCache[h] || null; });
        });
      }

      fetchBatch(wishlist).then(function(products) {
        // HTML escape helper
        function he(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
        var html = '';
        products.forEach(function(p, i) {
          if (!p) {
            // Product not found — collect stale handles for removal after loop
            return;
          }
          var rawImg = p.featured_image ? p.featured_image : (p.images && p.images.length > 0 ? p.images[0] : null);
          var img = rawImg ? rawImg.replace(/(\.\w+)(\?|$)/, '_200x$1$2') : null;
          var price = (p.price / 100).toLocaleString('sr-RS');
          var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
          var available = p.available;

          html += '<div class="wishlist-item" data-handle="' + he(p.handle) + '">';
          html += '<div class="wishlist-item__image">';
          if (img) {
            html += '<img src="' + he(img) + '" alt="' + he(p.title) + '" loading="lazy">';
          } else {
            html += '<div class="wishlist-item__image-placeholder">MCH</div>';
          }
          html += '</div>';
          html += '<div class="wishlist-item__info">';
          html += '<div class="wishlist-item__title"><a href="/products/' + he(p.handle) + '">' + he(p.title) + '</a></div>';
          html += '<div class="wishlist-item__price">' + he(price) + ' RSD</div>';
          html += '<div class="wishlist-item__actions">';
          if (available) {
            html += '<button class="wishlist-item__add-cart" data-variant-id="' + variantId + '">Dodaj u korpu</button>';
          } else {
            html += '<span class="wishlist-item__unavailable">Rasprodato</span>';
          }
          html += '<button class="wishlist-item__remove" data-handle="' + he(p.handle) + '">Ukloni</button>';
          html += '</div></div></div>';
        });

        // FIX: WISHLIST-STALE-SHIFT — collect stale handles after loop, remove in one pass
        var staleHandles = [];
        products.forEach(function(p, i) {
          if (!p && wishlist[i]) staleHandles.push(wishlist[i]);
        });
        if (staleHandles.length > 0) {
          staleHandles.forEach(function(h) {
            var idx = wishlist.indexOf(h);
            if (idx > -1) wishlist.splice(idx, 1);
          });
          saveWishlist();
          updateCount();
        }

        if (html === '') {
          emptyEl.style.display = 'block';
          itemsEl.innerHTML = '';
        } else {
          itemsEl.innerHTML = html;
        }
      });
    }

    // ===== DRAWER ACTIONS: add to cart, remove =====
    document.addEventListener('click', function(e) {
      // Add to cart from drawer
      var addBtn = e.target.closest('.wishlist-item__add-cart');
      if (addBtn) {
        var vid = addBtn.dataset.variantId;
        addBtn.textContent = '...';
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          addBtn.textContent = 'Dodato ✓';
          addBtn.classList.add('added');
          // Update cart count in header
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            document.querySelectorAll('.cart-count').forEach(function(el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? 'flex' : 'none';
            });
          });
        })
        .catch(function() {
          addBtn.textContent = 'Greška';
          addBtn.disabled = false;
        });
        return;
      }

      // Remove from drawer
      var removeBtn = e.target.closest('.wishlist-item__remove');
      if (removeBtn) {
        var handle = removeBtn.dataset.handle;
        var item = removeBtn.closest('.wishlist-item');
        // Animate out
        if (item) {
          item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          item.style.opacity = '0';
          item.style.transform = 'translateX(30px)';
        }
        setTimeout(function() {
          var idx = wishlist.indexOf(handle);
          if (idx > -1) wishlist.splice(idx, 1);
          saveWishlist();
          updateAllButtons(handle);
          loadDrawerItems();
        }, 300);
        return;
      }
    });

    function showToast(msg) {
      if (!toast) return;
      var span = toast.querySelector('span');
      if (span) span.textContent = msg;
      toast.classList.add('show');
      setTimeout(function() { toast.classList.remove('show'); }, 2500);
    }
  })();

  /* ===== SIZE GUIDE MODAL ===== */
  (function() {
    var overlay = document.querySelector('.size-guide-overlay');
    if (!overlay) return;

    var modalEl = overlay.querySelector('.size-guide-modal') || overlay;
    var sgPrevFocus = null;

    document.addEventListener('click', function(e) {
      if (e.target.closest('.size-guide-trigger')) {
        e.preventDefault();
        sgPrevFocus = document.activeElement;
        overlay.classList.add('active');
        window.mchLockScroll('sizeguide');
        var closeBtn = overlay.querySelector('.size-guide-modal__close');
        if (closeBtn) setTimeout(function(){ closeBtn.focus(); }, 50);
      }
    });

    function close() {
      overlay.classList.remove('active');
      window.mchUnlockScroll('sizeguide');
      if (sgPrevFocus && typeof sgPrevFocus.focus === 'function') {
        sgPrevFocus.focus();
        sgPrevFocus = null;
      }
    }

    overlay.querySelector('.size-guide-modal__close').addEventListener('click', close);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function(e) {
      if (!overlay.classList.contains('active')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var focusable = modalEl.querySelectorAll('button, a[href], input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])');
        if (focusable.length === 0) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Tabs
    overlay.querySelectorAll('.size-guide-tab').forEach(function(tab) {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', tab.classList.contains('active') ? 'true' : 'false');
      tab.addEventListener('click', function() {
        overlay.querySelectorAll('.size-guide-tab').forEach(function(t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var target = tab.dataset.tab;
        overlay.querySelectorAll('.size-guide-panel').forEach(function(p) {
          p.style.display = p.dataset.panel === target ? 'block' : 'none';
        });
      });
    });
  })();

  /* ===== SKELETON LOADING ===== */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    var vpBottom = window.innerHeight;
    document.querySelectorAll('.product-card, .bundle-card, .review-card, .episode-card').forEach(function(el, i) {
      // Skip elements already in (or above) the initial viewport — they should
      // render immediately at full opacity. Otherwise above-the-fold cards
      // flash visibly on every page load while waiting for IntersectionObserver
      // to fire.
      var rect = el.getBoundingClientRect();
      if (rect.top < vpBottom) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease ' + (i % 4 * 0.08) + 's, transform 0.5s ease ' + (i % 4 * 0.08) + 's';
      obs.observe(el);
    });
  }

  /* ===== MENU DRAWER (mobile) ===== */
  (function() {
    var drawer = document.getElementById('menuDrawer');
    var overlay = document.querySelector('.menu-drawer-overlay');
    if (!drawer || !overlay) return;

    function openDrawer() {
      overlay.hidden = false;
      requestAnimationFrame(function() {
        drawer.classList.add('active');
        overlay.classList.add('active');
        drawer.setAttribute('aria-hidden', 'false');
      });
      document.querySelectorAll('.menu-drawer-trigger').forEach(function(b) { b.setAttribute('aria-expanded', 'true'); });
      if (window.mchLockScroll) window.mchLockScroll('menuDrawer');
    }
    function closeDrawer() {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');
      document.querySelectorAll('.menu-drawer-trigger').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
      if (window.mchUnlockScroll) window.mchUnlockScroll('menuDrawer');
      setTimeout(function() { if (!drawer.classList.contains('active')) overlay.hidden = true; }, 300);
    }

    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('.menu-drawer-trigger');
      if (!trigger) return;
      e.preventDefault();
      if (drawer.classList.contains('active')) closeDrawer(); else openDrawer();
    });
    overlay.addEventListener('click', closeDrawer);
    var closeBtn = drawer.querySelector('.menu-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('.menu-drawer__nav a, .menu-drawer__account').forEach(function(a) { a.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && drawer.classList.contains('active')) closeDrawer(); });
  })();

}

// Run immediately if DOM is already parsed (which is typical since we're
// idle-loaded from theme.liquid), otherwise wait for DOMContentLoaded.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mchEnhancementsInit);
} else {
  mchEnhancementsInit();
}
